export const shadows = {
  card: {
    default: '0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1);',
  },
  drawer: {
    default:
      '-5px 0px 25px rgba(0, 0, 0, 0.1), -5px 0px 10px rgba(0, 0, 0, 0.04);',
    notifications:
      '0px 10px 30px rgba(0, 0, 0, 0.06), 0px 10px 30px rgba(0, 0, 0, 0.1)',
  },
}
